import React, { useRef } from 'react'
import { Redirect, } from "react-router-dom";
import { getRights, isLoggedIn } from "../functions/Auth";
import { Col, Container, Label, Row, Spinner, Button } from "reactstrap";

import NavSidebar from "./components/NavSidebar";
import AppPage from "../AppPage";
import SpinnerOverlay from "./components/SpinnerOverlay";
import ScreenPullToRefresh from "./components/ScreenPullToRefresh";


import { resizeFile, getImageType } from "../functions/Utility";

import {
    getAllInvoiceFormalPromoImage, getInvoiceFormalPromoImageInUse, getInvoiceFormalPromoImageNotInUse, addInvoiceFormalPromoImage,
    setInvoiceFormalPromoImageInUse,
    setInvoiceFormalPromoImageNotInUse,
    deleteInvoiceFormalPromoImage
} from "../functions/InvoiceFormalPromoImage";

import WSPGallery from './components/WSPGallery';


function InvoiceFormalPromoImageGalleryScreen() {

    // Delivery Photo from dB
    const [invoiceFormalPromoImage, setInvoiceFormalPromoImage] = React.useState([]);

    async function getPhotoFromBackend() {
        // deliveryPhoto from backend
        let invoiceFormalPromoImageGeneral = [];
        let InvoiceFormalPromoImageInUse = await getInvoiceFormalPromoImageInUse();
        let InvoiceFormalPromoImageNotInUse = await getInvoiceFormalPromoImageNotInUse();
        invoiceFormalPromoImageGeneral = invoiceFormalPromoImageGeneral.concat(InvoiceFormalPromoImageInUse);
        invoiceFormalPromoImageGeneral = invoiceFormalPromoImageGeneral.concat(InvoiceFormalPromoImageNotInUse);
        setInvoiceFormalPromoImage(invoiceFormalPromoImageGeneral);
    };

    // upload delivery photo
    const inputUploadExistingPhoto = useRef(null);

    const uploadImageTodB = async (imageName, imageToUpload) => {

        //resize file will auto encoded to base 64
        let imageToUploadResized = await resizeFile(imageToUpload);
        let imageBase64 = imageToUploadResized;
        let imageBase64HeaderRemoved = imageBase64.split(',')[1];
        // remove the header from the image
        const testData = await addInvoiceFormalPromoImage(imageName.split('.')[0], imageBase64HeaderRemoved);
        addImageToLocal(imageName.split('.')[0], imageBase64HeaderRemoved)
    };

    const addImageToLocal = (imageName, imageBase64HeaderRemoved) => {
        const imageDataToAdd = Object.assign({}, {
            ImageID: imageName,
            ImageType: "inUse",
            ImageName: imageName,
            ImageFileType: `image/${getImageType(imageBase64HeaderRemoved).ext}`,
            imageMatchLastUpdateTime: Date.now(),
            imageMatchUserID: '',
            ImageBase64Content: imageBase64HeaderRemoved
        })
        invoiceFormalPromoImage.push(imageDataToAdd);
        setInvoiceFormalPromoImage(invoiceFormalPromoImage);
    };


    //  Initial loading
    const [initial, setInitial] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    //  Item onClick
    const [itemIDClicked, setItemIDClicked] = React.useState('');

    //  Pull down to refresh
    async function onPullDownRefresh() {
        setIsLoading(true);
        await getPhotoFromBackend();
        setIsLoading(false);
    }



    //  Run when state value changes
    React.useEffect(() => {
        //  Initial API call
        const initData = async () => {
            //  Load once only
            setInitial(true);
            await getPhotoFromBackend();
            setIsLoading(false);
        };
        if (!initial) {
            initData().then();
        }
    }, [initial, invoiceFormalPromoImage]);

    return (isLoggedIn() && getRights() !== 'driver') ? (

        <Container className="pl-3 pr-3">

            {isLoading ? <SpinnerOverlay /> : ""}
            <NavSidebar />
            <ScreenPullToRefresh onRefresh={async () => await onPullDownRefresh()}
                disabled={itemIDClicked !== ''}>

                <Container className="align-self-end" style={{ width: 'fit-content', height: 'fit-content' }}>
                    <input
                        type='file'
                        ref={inputUploadExistingPhoto}
                        style={{
                            display: 'none'
                        }}
                        accept="image/*"
                        onChange={async (e) => {
                            if (e.target.files[0] !== undefined) {
                                // if is undefined, do not do anything
                                setIsLoading(true);
                                await uploadImageTodB(e.target.files[0].name, e.target.files[0]);
                                setIsLoading(false);
                            }
                        }}
                    />
                    <Button className="align-self-end m-2" color="warning" size="lg" onClick={() => inputUploadExistingPhoto.current.click()}>
                        <i className="fa fa-upload" />
                    </Button>
                </Container>
                <WSPGallery
                    URLBase64s={invoiceFormalPromoImage}
                    setIsLoading={setIsLoading}
                    setPictureInUseFcn={async (imageName) => {
                        await setInvoiceFormalPromoImageInUse(imageName);
                    }}
                    setPictureNotInUseFcn={async (imageName) => {
                        await setInvoiceFormalPromoImageNotInUse(imageName);
                    }}
                    deletePictureFcn={async (imageName) => {
                        console.log("testing")
                        await deleteInvoiceFormalPromoImage(imageName);
                    }}

                />
            </ScreenPullToRefresh>
        </Container>
    ) : (
        <Redirect to={AppPage.root.route} />
    )
}

export default InvoiceFormalPromoImageGalleryScreen
